/**
 * @file Footer with social icons and contact info.
 */
import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Footer.css';

/** Footer displayed on all pages. */
function Footer() {
  const { language } = useLanguage();

  const loc = (value) => {
    if (typeof value === 'object' && (value.sv || value.en)) {
      return value[language] || value.sv || value.en || '';
    }
    return value;
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-info">
            <h3>Ellen Engineer</h3>
            <p>Engineer & Developer</p>
          </div>
          <div className="footer-socials">
            <a href="mailto:carlssonellen@live.se" className="footer-social-link" aria-label="Email">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
              <span>carlssonellen@live.se</span>
            </a>
            <a href="https://www.linkedin.com/in/ellen-carlsson-ab04451b4" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              <span>LinkedIn</span>
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Ellen Carlsson. {loc({ sv: 'Alla rättigheter reserverade.', en: 'All rights reserved.' })}</p>
          <p className="footer-meta">
            Font: <a href="https://hackedfont.com" target="_blank" rel="noopener noreferrer">Hacked</a> {loc({ sv: 'av', en: 'by' })} David Libeau (CC BY 4.0)
          </p>
          <p className="footer-meta">{loc({ sv: 'Uppdaterad: 13 feb 2026', en: 'Updated: Feb 13, 2026' })}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
